import Image from 'next/image';
import { useSchoolAssets } from '@/hooks/useSchoolAssets';

interface SchoolLogoProps {
  width?: number;
  height?: number;
  className?: string;
}

export function SchoolLogo({ width = 40, height = 40, className = '' }: SchoolLogoProps) {
  const { logoUrl, isLoading } = useSchoolAssets();
  const defaultLogo = '/logo.png';
  
  if (isLoading) {
    return <div className={`animate-pulse bg-gray-200 rounded ${className}`} style={{ width, height }} />;
  }

  return (
    <Image
      src={logoUrl || defaultLogo}
      alt="School Logo"
      width={width}
      height={height}
      className={className}
      priority={true}
    />
  );
}
